import { ModalState, NoError } from '../../modal-state'

export interface ValidationResult {
  postProcess: () => void
  modalState: ModalState
  readonly isInvalid: boolean
}

export const success: () => ValidationResult = () => ({
  modalState: new NoError(),
  postProcess: () => { /* nothing to do */ },
  isInvalid: false,
})

export const foldValidationResults = (results: ValidationResult[]) =>
  (onSuccess: () => void) => {
    const invalidResult = results.find(result => result.isInvalid)
    if (invalidResult) {
      invalidResult.postProcess()

      return invalidResult.modalState
    }

    onSuccess()

    return new NoError()
  }

export interface Specification<T> {
  validate(input: T | null | undefined): ValidationResult
}

export abstract class SpecificationList<I, L extends Specification<I>> {
  constructor(private readonly list: L[]) { }

  validate(input: I | null | undefined): ValidationResult {
    const error = this.list.map(specification => specification.validate(input)).find(result => result.isInvalid)

    return error || success()
  }
}
